export default __webpack_public_path__ + "static/media/all.08ad641a.svg";